import { render } from "./NotreApproche.vue?vue&type=template&id=04dfd0de&scoped=true"
import script from "./NotreApproche.vue?vue&type=script&lang=js"
export * from "./NotreApproche.vue?vue&type=script&lang=js"

import "./NotreApproche.vue?vue&type=style&index=0&id=04dfd0de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dfd0de"]])

export default __exports__